import PosVenda from "./PosVenda";

export default PosVenda;
